// extracted by mini-css-extract-plugin
module.exports = {"root":"ActionCardLayout_root__2xBhC","footer":"ActionCardLayout_footer__Kvj0X"};